<template>
  <tender-form-label :key="index" 
    :label="options.Name"
    :prop="options.Key"
    :rules="rules"
  >
    <bear-input v-model="form[options.Key]" :attrs="attrs" @input="inputChangeHandle" :disabled="options.Disabled"></bear-input>
    <el-button type="primary" size="small" :disabled="options.Disabled" @click="setValueByCode">获取</el-button>
  </tender-form-label>
</template>
<script>
import { mixForFormItem } from '../../../js/mixins'
import { mapActions } from 'vuex'
import BearInput from '~@/input/src'
import utils from '../../../js/utils'
export default {
  name: 'FormInputCode',
  mixins: [mixForFormItem],
  components: {BearInput},
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options = {}} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        this.setFormItemValue(options.Value || '')
      }).catch(() => null)
    },
    inputChangeHandle() {
      this.doValidate()
    },
    setValueByCode() {
      let {param, options} = this
      this.setBaOrBjData({param, options})
    },
    ...mapActions(['setBaOrBjData'])
  }
}
</script>
